export default function ErrorComponent({error}) {
    return <p>An Error Occurred: {error}</p>;
}